var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "login-main",
    attrs: {
      "ma-0": "",
      "pa-3": "",
      "row": "",
      "justify-center": "",
      "align-start": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "login-wrapper d-flex flex-column align-stretch",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg4": "",
      "xl3": "",
      "pa-3": ""
    }
  }, [_c('a', {
    staticClass: "login-banner",
    attrs: {
      "href": "https://www.opencap.ai",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticClass: "login-banner-highlight"
  }, [_vm._v("OpenCap 2.0 is here")]), _c('span', {
    staticClass: "login-banner-details"
  }, [_vm._v("New UI/UX · New mobile app · Monocular support")]), _c('span', {
    staticClass: "login-banner-cta"
  }, [_vm._v("Learn more at "), _c('strong', [_vm._v("opencap.ai")]), _vm._v(" →")])]), _c('div', {
    staticClass: "login-card"
  }, [_c('h1', {
    staticClass: "login-title"
  }, [_vm._v("Login")]), _c('ValidationObserver', {
    ref: "observer",
    staticClass: "login-form d-flex flex-column",
    attrs: {
      "tag": "form"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onLogin();
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var invalid = _ref.invalid;
        return [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "Username",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": "Username",
                  "outlined": "",
                  "dense": "",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.username,
                  callback: function ($$v) {
                    _vm.username = $$v;
                  },
                  expression: "username"
                }
              })];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "Password",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": "Password",
                  "outlined": "",
                  "dense": "",
                  "error": errors.length > 0,
                  "error-messages": errors[0],
                  "append-icon": _vm.show_password ? 'mdi-eye' : 'mdi-eye-off',
                  "type": _vm.show_password ? 'text' : 'password'
                },
                on: {
                  "click:append": function ($event) {
                    _vm.show_password = !_vm.show_password;
                  }
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v;
                  },
                  expression: "password"
                }
              })];
            }
          }], null, true)
        }), _vm.show_remember_checkbox ? _c('v-checkbox', {
          staticClass: "login-remember",
          attrs: {
            "label": "Remember this device for 90 days",
            "hide-details": ""
          },
          model: {
            value: _vm.remember_device,
            callback: function ($$v) {
              _vm.remember_device = $$v;
            },
            expression: "remember_device"
          }
        }) : _vm._e(), _c('v-btn', {
          staticClass: "login-btn",
          attrs: {
            "type": "submit",
            "loading": _vm.loading,
            "disabled": _vm.submitted && invalid || _vm.loading
          },
          on: {
            "click": function ($event) {
              return _vm.onLogin();
            }
          }
        }, [_vm._v("Login")])];
      }
    }])
  }), _c('div', {
    staticClass: "login-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ResetPassword'
      }
    }
  }, [_vm._v("Forgot your username or password?")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_vm._v("Don't have an account? Sign Up")])], 1)], 1), _c('div', {
    staticClass: "login-help"
  }, [_c('a', {
    attrs: {
      "href": "https://www.opencap.ai/get-started",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Get Started")]), _c('span', {
    staticClass: "login-help-sep"
  }, [_vm._v("·")]), _c('a', {
    attrs: {
      "href": "https://www.opencap.ai/best-practices",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Best Practices")])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }